const blocks = document.querySelectorAll('section.text-cards');

if (blocks.length > 0) {
  blocks.forEach((block) => {
    const items = block.querySelectorAll('ul li');
    items.forEach((item) => {
      const expandableSection = item.querySelector('.expandable-section');
      if (expandableSection) {
        const moreBtn = expandableSection.querySelector('.expand-btn');
        const expandableText = expandableSection.querySelector('.expandable-text');

        item.addEventListener('click', (e) => {
          e.preventDefault();
          moreBtn.classList.toggle('expanded');
          expandableText.classList.toggle('expanded');
        });
      }
    });
  });
}
